export const STORYPHONE_DETAILS = 'STORYPHONE_DETAILS';
export const STORYPHONE_DETAILS_BY_ID = 'STORYPHONE_DETAILS_BY_ID';
export const DELETED_STORYPHONE = 'DELETED_STORYPHONE';
export const STORYPHONE_MODELS = 'STORYPHONE_MODELS';
